import styled from "styled-components";
import { Paragraph } from "../../../atoms/Typography/Typography.styles";

export const InfoWindow = styled.div`
  
`

export const InfoWindowTags = styled.div`
  
`

export const InfoWindowContent = styled.div`
  ${Paragraph} {
    word-break: break-word;
  }
`

export const InfoWindowActions = styled.div`
  padding-top: ${({ theme }) => theme.rem(16)};

  button,
  a {
    width: 100%;
  }
`

